export const styles = {
  global: {
    body: {
      color: `neutrals.white`,
      background: `colours.colour-2`
    }
  }
};
